import { put, call, takeLatest } from 'redux-saga/effects'
import { apiFetchFaq } from 'containers/Faq/services'
import { FETCH_SUGGESTED } from './constants'
import { fetchSuggestedApi } from './services'
import { fetchSuggested } from './actions'

function* fetchSuggestedWorker(action) {
  const response = yield call(
    fetchSuggestedApi,
    action.id,
    action.contentType,
    action.deviceId
  )

  // Fetch content for faqs to display it inline
  for (const item of response) {
    if (item.object_type === 'faq') {
      const faq = yield call(apiFetchFaq, item.pk)
      item.val = faq.val
    }
  }

  if (Array.isArray(response)) {
    yield put(fetchSuggested.success(response))
  }
}

export default function* watcher() {
  yield takeLatest(FETCH_SUGGESTED.REQUEST, fetchSuggestedWorker)
}
